export default __webpack_public_path__ + "static/media/reactjs.724c2718.png";